import React from 'react';
import { Button } from 'antd';
import { useTranslations } from 'next-intl';
import { PatternFormat } from 'react-number-format';

import { useCheckSms } from 'modules/auth';

import { IUserData } from '..';

interface IProps {
  data: IUserData;
  setData: React.Dispatch<React.SetStateAction<IUserData>>;
}

const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return '';

  // Extract parts of the number
  const countryCode = phoneNumber.slice(0, 4);
  const operatorCode = phoneNumber.slice(4, 6);
  const maskedPart = '***';
  const lastPart1 = phoneNumber.slice(9, 11);
  const lastPart2 = phoneNumber.slice(11, 13);

  return `${countryCode} (${operatorCode}) ${maskedPart} ${lastPart1} ${lastPart2}`;
};

const OtpStep: React.FC<IProps> = ({ setData, data }) => {
  const t = useTranslations('auth');
  const { mutate, isLoading } = useCheckSms();

  const onCheckSms = () => {
    if (data.phone) {
      mutate({ phone: data?.phone, code: data.code, platform: 'desktop-web' });
    }
  };

  return (
    <>
      <h2 className="mb-4 text-2xl font-semibold">{t('otp_title')} 📨</h2>
      <p className="mb-4 text-gray-600">
        {formatPhoneNumber(data?.phone)} {t('otp_desc')}
      </p>

      <PatternFormat
        onKeyDown={e => {
          if (e.key === 'Enter') {
            onCheckSms();
          }
        }}
        format="#####"
        mask="_"
        allowEmptyFormatting
        onValueChange={e => setData(prev => ({ ...prev, code: e.value }))}
        placeholder="_ _ _ _ _"
        className="!h-11 w-full  !rounded-md !border-transparent !bg-[#f2f3f5] !p-3 hover:!outline-green-500 focus:!outline-green-500 "
      />

      <Button
        loading={isLoading}
        onClick={onCheckSms}
        className="!mt-5 !w-full !rounded-md !border-none !bg-green-500 !py-5 !text-white"
      >
        {t('kirish')}
      </Button>
    </>
  );
};

export default OtpStep;
